import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NEW_URL_SERVICIOS_EFIKAR } from '../../../../config/config';

@Injectable()
export class UnidadesMedidaService {

  constructor(public http: HttpClient) { }

  listarUnidades() {
    // const url = NEW_URL_SERVICIOSPOSTGRES + 'almacen/retornaAllProductos';
    // return this.http.post(NEW_URL_SERVICIOSPOSTGRES + 'unidadesdemedida/retornaAllUnidadesMedida', {'accion': ''});
    return this.http.post(NEW_URL_SERVICIOS_EFIKAR + 'productos/retornaAllUnidadesMedida2', {'accion': ""});

    // return this.http.post(url, producto)
  }
  
  retornaUnidadesMedida() {      
    // const url = NEW_URL_SERVICIOSPOSTGRES + 'almacen/retornaAllProductos';
    //return this.http.post(NEW_URL_SERVICIOSPOSTGRES + 'unidadesdemedida/retornaAllUnidadesMedida', {'accion': ""});
    return this.http.post(NEW_URL_SERVICIOS_EFIKAR + 'unidadesdemedida/retornaAllUnidadesMedida', {'accion': ""});
    // return this.http.post(url, producto)
    
  }
}
